import './App.css';
import { BrowserRouter as Router, useRoutes, Routes, Route, Link, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { IntlProvider } from 'react-intl';
import { CookiesProvider } from 'react-cookie';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { withNamespaces } from 'react-i18next'

import _404Page from './components/404Page';
import ProtectedRoute from './page/Auth/ProtectedRoute';
import { TRADINGVIEW_CONFIGS_SUB_PATH, TRADINGVIEW_TRANSACTIONS_SUB_PATH} from "./constants2"
import Main from './page/Main';
import Login from './page/Auth/Login';

const customTheme = extendTheme({
  fonts: {
      heading: 'Helvetica Neue, sans-serif',
      body: "Red Hat Mono, monospace",
  }
});

function App({ t }) {
  return (
    <CookiesProvider>
      <ChakraProvider theme={customTheme}>
        <IntlProvider locale='vi'>
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
            {/* <SolanaProvider> */}
              <Router>
                <Routes>
                  <Route element={<ProtectedRoute />}>
                    <Route path='/' element={<Main />} />
                    {/* <Route path='/strategy-trading' element={<Main />} />
                    <Route path='/profit-n-loss' element={<Main />} />
                    <Route path='/wallet' element={<Main />} />
                    <Route path='/order' element={<Main />} />
                    <Route path='/referral' element={<Main />} />
                    <Route path='/my-account' element={<Main />} />
                    <Route path='/accounts' element={<Main />} />
                    <Route path='/wallet-trackings' element={<Main />} />
                    <Route path='/system-configs' element={<Main />} />
                    <Route path='/analysic-tickers' element={<Main />} /> */}
                    <Route path={TRADINGVIEW_TRANSACTIONS_SUB_PATH} element={<Main />} />
                    <Route path={TRADINGVIEW_CONFIGS_SUB_PATH} element={<Main />} />
                  </Route>
                  <Route path='/login' element={<Login />} />
                </Routes>
              </Router>
            {/* </SolanaProvider> */}
          </GoogleOAuthProvider>
        </IntlProvider>
      </ChakraProvider>
    </CookiesProvider>
  );
}

export default withNamespaces()(App);